import { useEffect, useState } from "react";
import { FileDown, FileSpreadsheet, FileText, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { api, API_BASE, IDR, DATE, formatErr } from "@/lib/api";

const REPORTS = [
  { title: "Rekap Batch Produksi", desc: "Daftar seluruh batch dengan status, target, dan hasil.", pdf: "/reports/batches/pdf", xlsx: "/reports/batches/xlsx" },
];

export default function Reports() {
  const [hpps, setHpps] = useState([]);

  useEffect(() => { (async () => {
    try { const { data } = await api.get("/hpp"); setHpps(data); } catch (e) { toast.error(formatErr(e)); }
  })(); }, []);

  return (
    <div className="space-y-6">
      <div>
        <span className="gc-label">Laporan</span>
        <h1 className="gc-h1 mt-1">Ekspor Laporan</h1>
        <p className="mt-2 text-slate-500 max-w-2xl">Unduh laporan HPP dan batch produksi dalam format PDF dan Excel. Setiap ekspor tercatat pada Audit Log.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {REPORTS.map((r) => (
          <div key={r.title} className="gc-card">
            <div className="flex items-start justify-between">
              <div>
                <FileText className="w-6 h-6 text-emerald-600" />
                <h3 className="gc-h3 mt-3">{r.title}</h3>
                <p className="text-sm text-slate-500 mt-1">{r.desc}</p>
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              <a href={`${API_BASE}${r.pdf}`} target="_blank" rel="noreferrer" className="gc-btn-ghost" data-testid={`btn-report-pdf-${r.title}`}><FileDown className="w-4 h-4" /> PDF</a>
              <a href={`${API_BASE}${r.xlsx}`} target="_blank" rel="noreferrer" className="gc-btn-ghost" data-testid={`btn-report-xlsx-${r.title}`}><FileSpreadsheet className="w-4 h-4" /> Excel</a>
            </div>
          </div>
        ))}
      </div>

      <div>
        <h3 className="gc-h3 mb-3">Laporan HPP per Perhitungan</h3>
        <div className="gc-card p-0 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[11px] uppercase tracking-widest text-slate-500">
                <tr>
                  <th className="text-left px-4 py-3">No.</th>
                  <th className="text-left px-4 py-3">Jenis</th>
                  <th className="text-right px-4 py-3">HPP/Unit</th>
                  <th className="text-left px-4 py-3">Dibuat</th>
                  <th className="text-right px-4 py-3">Ekspor</th>
                </tr>
              </thead>
              <tbody>
                {hpps.map((h) => (
                  <tr key={h.id} className="border-t border-slate-100">
                    <td className="px-4 py-3 font-semibold">{h.calc_no}</td>
                    <td className="px-4 py-3">{h.kind === "actual" ? "Aktual" : "Standar"}</td>
                    <td className="px-4 py-3 text-right font-semibold text-emerald-700">{IDR(h.hpp_per_unit)}</td>
                    <td className="px-4 py-3">{DATE(h.created_at)}</td>
                    <td className="px-4 py-3 text-right">
                      <div className="flex justify-end gap-2">
                        <a href={`${API_BASE}/reports/hpp/${h.id}/pdf`} target="_blank" rel="noreferrer" className="gc-btn-ghost text-xs"><FileDown className="w-3.5 h-3.5" /> PDF</a>
                        <a href={`${API_BASE}/reports/hpp/${h.id}/xlsx`} target="_blank" rel="noreferrer" className="gc-btn-ghost text-xs"><FileSpreadsheet className="w-3.5 h-3.5" /> Excel</a>
                      </div>
                    </td>
                  </tr>
                ))}
                {!hpps.length && <tr><td colSpan={5} className="text-center py-10 text-slate-400">Belum ada perhitungan HPP.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
